import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTheme } from '@rescui/ui-contexts';
import { optionType, optionsGroupType, noOptionsMessageType } from '../common-prop-types.js';
import SelectTrigger from './trigger.js';
import FormTriggerWrapper from './form-trigger-wrapper.js';
import styles from './native-select.p.module.css.js';
var DEFAULT_NO_OPTIONS_MESSAGES = {
  noOptions: 'No options',
  loading: 'Loading...'
};
var PLACEHOLDER_VALUE = '__placeholder__';

function isString(s) {
  return Object.prototype.toString.call(s) === '[object String]';
}

var isOptionsGroup = function isOptionsGroup(optionOrGroup) {
  return typeof optionOrGroup.options !== 'undefined';
};

var collectOptionGroupValues = function collectOptionGroupValues(options) {
  return _mapInstanceProperty(options).call(options, function (_ref) {
    var value = _ref.value;
    return value;
  }).join('-');
};

var Option = function Option(_ref2) {
  var value = _ref2.value,
      label = _ref2.label,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  return /*#__PURE__*/React.createElement("option", {
    value: value,
    disabled: disabled
  }, label);
};

var OptionGroup = function OptionGroup(_ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? '' : _ref3$label,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  return /*#__PURE__*/React.createElement("optgroup", {
    label: label,
    disabled: disabled
  }, _mapInstanceProperty(options).call(options, function (_ref4) {
    var value = _ref4.value,
        optionLabel = _ref4.label,
        optionDisabled = _ref4.disabled;
    return /*#__PURE__*/React.createElement(Option, {
      key: value,
      value: value,
      label: optionLabel,
      disabled: optionDisabled
    });
  }));
};

var OptionsWithGroups = function OptionsWithGroups(_ref5) {
  var optionsWithGroups = _ref5.optionsWithGroups;
  return /*#__PURE__*/React.createElement(React.Fragment, null, _mapInstanceProperty(optionsWithGroups).call(optionsWithGroups, function (optionOrGroup) {
    if (isOptionsGroup(optionOrGroup)) {
      var _context;

      var group = optionOrGroup;
      return /*#__PURE__*/React.createElement(OptionGroup, {
        key: _concatInstanceProperty(_context = "group--".concat(group.label, "--")).call(_context, collectOptionGroupValues(group.options)),
        options: group.options,
        disabled: group.disabled,
        label: group.label
      });
    }

    var option = optionOrGroup;
    return /*#__PURE__*/React.createElement(Option, {
      key: option.value,
      value: option.value,
      label: optionOrGroup.label,
      disabled: optionOrGroup.disabled
    });
  }));
};

function findSelectedOption(options, selectedValue) {
  var result = null;

  var checkOption = function checkOption(option) {
    if (result === null || option.value === selectedValue) {
      result = option;
    }
  };

  options.forEach(function (optionOrGroup) {
    if (isOptionsGroup(optionOrGroup)) {
      var _group$options;

      var group = optionOrGroup;
      (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.forEach(checkOption);
    } else {
      checkOption(optionOrGroup);
    }
  });
  return result;
}

function getNoOptionsMessage(noOptionsMessage, isLoading) {
  var _ref6 = isString(noOptionsMessage) ? _objectSpread(_objectSpread({}, DEFAULT_NO_OPTIONS_MESSAGES), {}, {
    noOptions: noOptionsMessage
  }) : _objectSpread(_objectSpread({}, DEFAULT_NO_OPTIONS_MESSAGES), noOptionsMessage),
      noOptions = _ref6.noOptions,
      loading = _ref6.loading;

  if (isLoading) {
    return loading;
  } else {
    return noOptions;
  }
}

var SIZE_STYLES = {
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
}; // eslint-disable-next-line complexity

var NativeSelect = function NativeSelect(_ref7) {
  var _context2;

  var _ref7$options = _ref7.options,
      options = _ref7$options === void 0 ? [] : _ref7$options,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 'm' : _ref7$size,
      themeFromProps = _ref7.theme,
      _ref7$className = _ref7.className,
      className = _ref7$className === void 0 ? null : _ref7$className,
      style = _ref7.style,
      _ref7$value = _ref7.value,
      value = _ref7$value === void 0 ? undefined : _ref7$value,
      onChange = _ref7.onChange,
      placeholder = _ref7.placeholder,
      _ref7$isLoading = _ref7.isLoading,
      isLoading = _ref7$isLoading === void 0 ? false : _ref7$isLoading,
      _ref7$isDisabled = _ref7.isDisabled,
      isDisabled = _ref7$isDisabled === void 0 ? false : _ref7$isDisabled,
      trigger = _ref7.trigger,
      label = _ref7.label,
      note = _ref7.note,
      error = _ref7.error,
      noOptionsMessage = _ref7.noOptionsMessage,
      name = _ref7.name,
      boldLabel = _ref7.boldLabel;
  var theme = useTheme(themeFromProps);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var handleChange = function handleChange(event) {
    var newValue = event.target.value;
    var selectedOption = findSelectedOption(options, newValue);

    if (onChange) {
      onChange(selectedOption);
    }
  };

  var optionList = /*#__PURE__*/React.createElement(OptionsWithGroups, {
    optionsWithGroups: placeholder !== null ? _concatInstanceProperty(_context2 = [{
      value: PLACEHOLDER_VALUE,
      label: options.length > 0 ? placeholder : getNoOptionsMessage(noOptionsMessage, isLoading),
      disabled: true
    }]).call(_context2, _toConsumableArray(options)) : options
  });

  var _trigger;

  if (trigger) {
    _trigger = trigger({
      selectedLabel: value === null || value === void 0 ? void 0 : value.label,
      selectedValue: value === null || value === void 0 ? void 0 : value.value,
      placeholder: placeholder,
      hovered: hovered
    });
  } else {
    _trigger = /*#__PURE__*/React.createElement(SelectTrigger, {
      theme: theme,
      size: size,
      isOpen: false,
      selected: value,
      placeholder: placeholder,
      searchInput: "",
      isClearable: false,
      isLoading: isLoading,
      isDisabled: isDisabled,
      error: Boolean(error)
    });
  }

  return /*#__PURE__*/React.createElement(FormTriggerWrapper, {
    className: className,
    theme: theme,
    size: size,
    error: error,
    label: label,
    note: note,
    onKeyDown: function onKeyDown() {
      return false;
    },
    boldLabel: boldLabel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.main,
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    style: style,
    "data-test": "native-select"
  }, _trigger, /*#__PURE__*/React.createElement("select", {
    "data-test": "native-select_select",
    className: cn(styles.select, SIZE_STYLES[size]),
    disabled: isDisabled ? true : undefined,
    onChange: handleChange,
    name: name,
    value: (value === null || value === void 0 ? void 0 : value.label) !== '' ? value === null || value === void 0 ? void 0 : value.value : PLACEHOLDER_VALUE
  }, optionList)));
};

NativeSelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.oneOfType([optionType, optionsGroupType])),
  value: optionType,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['m', 's', 'l']),
  theme: PropTypes.oneOf(['light', 'dark']),
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  trigger: PropTypes.func,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  label: PropTypes.node,
  note: PropTypes.node,
  noOptionsMessage: noOptionsMessageType,
  style: PropTypes.object,
  name: PropTypes.string,
  boldLabel: PropTypes.bool
};
export { NativeSelect as default };
